import { Box } from '@mui/material';
import styled from 'styled-components';

export const EmptyCardContentContainer = styled(Box)`
  && {
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: ${({ theme }) => theme.spacing(7)};

    & > div > svg {
      color: ${({ theme }) => theme.palette.primary.main};
      width: ${({ theme }) => theme.spacing(7)};
      height: ${({ theme }) => theme.spacing(7)};
    }

    & p {
      color: ${({ theme }) => theme.palette.text.secondary};
      text-align: center;
      max-width: ${({ theme }) => theme.spacing(50)};
      ${({ theme }) => theme.typography.p8};
    }
  }
`;
